module.exports = __webpack_public_path__ + "static/01-4fc3633bc0e53141711400e8a44d9467.png";